













































































































































































































































































import {Component, Ref, Vue, Watch} from 'vue-property-decorator';
import {isMobileNoValidated, isEmailValidated} from '@/utils/validateUtils';
import {
  PostAuthSmsRequest,
  GetAuthSmsRequest,
  GetDepartmentsService,
  GetJobDutyService,
  AdminsServiceByAdminNoRequest,
  AdminsService,
  GetAuthorityGroupsRequest,
  AuthorityGroup,
  PutAdminsServiceByAdminNoRequest,
  DeleteAdminsServiceByAdminNoRequest,
} from 'supporter';
import {Admin, PopupRequestData} from '@/types';
import {namespace} from 'vuex-class';
import {toI18n} from '@/utils/commonUtils';
import {htmlEncode, htmlRestore} from '@/utils/formatUtils';
import {addDay} from '@/utils/dateUtils';
import DateCalendar from '@/components/common/datepicker/DateCalendar.vue';
import AccessControlLayerPopup from '@/views/admin/AccessControlLayerPopup.vue';
import OtpSettingIframe from '@/components/header/OtpSettingIframe.vue';
import LayerPopup from '@/components/LayerPopup.vue';
import ReasonDetailLayerPopup from '@/components/ReasonDetailLayerPopup.vue';

const adminModule = namespace('admin');

interface DepartmentListInfo {
  select: number;
  list: GetDepartmentsService[];
}

interface JobDutyListInfo {
  select: number;
  list: GetJobDutyService[];
}

enum AUTH_BY_SMS {
  NONE,
  SENDING,
  COMPLETE,
  ERROR
}

interface AuthSmsInfo {
  status: AUTH_BY_SMS;
  certKey: string;
}

interface AuthGroupListInfo {
  select: number;
  list: AuthorityGroup[];
}

@Component({ components: {AccessControlLayerPopup, DateCalendar, OtpSettingIframe, LayerPopup, ReasonDetailLayerPopup} })
export default class AdminEdit extends Vue {
  @adminModule.Getter('admin') private admin!: Admin;

  private readonly VUE_APP_COMMERCE_AUTH = process.env.VUE_APP_COMMERCE_AUTH;
  private isOpenExternalGuideModal = false;
  private reasonDetailModal = { 
    type: 'EDIT',
    isOpen: false,
    reasonDetail: '',
  };

  private closeReasonDetailModal() {
    this.reasonDetailModal.isOpen = false
  }

  private openReasonDetailModal(type: 'EDIT' | 'DELETE') {
    this.reasonDetailModal.isOpen = true;
    this.reasonDetailModal.type = type;
  }

  private confirmReasonDetailModal(value: string) {
    this.reasonDetailModal.reasonDetail = value;

    if (!this.reasonDetailModal.reasonDetail) {
      alert('사유를 입력해주세요.');

      return;
    }

    this.closeReasonDetailModal();

    if (this.reasonDetailModal.type === 'EDIT') {
      this.saveAdmin();

      return;
    }

    this.deleteAdmin();
  }

  private openExternalModal() {
    this.isOpenExternalGuideModal = true;
  }

  private externalAccessGuideData: PopupRequestData = {
    id: 'externalAccessGuide',
    width: 560,
    title: '외부접속',
    hasConfirmBtn: false
  };

  private get displayOtpColumn() {
    const pathArray = this.$route.path.split('/');
    const adminNo = Number(pathArray[pathArray.length - 1] ?? 0);

    return this.admin.no === adminNo;
  }


  private departmentInfo: DepartmentListInfo = {
    select: 0,
    list: [{departmentName: this.toI18n('SELECT_DEPARTMENT'), departmentNo: -1, serviceNo: -1}]
  };
  private jobDutyInfo: JobDutyListInfo = {
    select: 0,
    list: [{jobDutyName: this.toI18n('SELECT_JOB_DUTY'), jobDutyNo: -1, serviceNo: -1}]
  };
  private adminInfo: AdminsService = {
    adminName: '',
    authorityGroup: {
      no: -1,
      name: ''
    },
    jobDuty: {
      no: -1,
      name: ''
    },
    contact: {
      mobileNo: '',
      phoneNo: '',
      email: ''
    },
    adminId: '',
    adminRole: null,
    department: {
      no: -1,
      name: ''
    },
    jobPositionName: '',
    externalAccessEnabled: false,
    otp: {
      used: false,
    },
    expireDate: '',
    commerceAccount: false,
	  permittedIpAddresses: null,
  };
  private authSmsInfo: AuthSmsInfo = {
    status: AUTH_BY_SMS.COMPLETE,
    certKey: ''
  };
  private authGroupInfo: AuthGroupListInfo = {
    select: 0,
    list: [
      {
        no: -1,
        malls: [],
        permitsPrivateInformation: false,
        adminCount: 0,
        creatorName: '',
        name: this.toI18n('CHOOSE'),
        description: '',
        modifierName: '',
        modificationDateTime: '',
        allowsMarketingDirection: false,
        creationDateTime: '',
        smsReceived: false,
      }
    ]
  };

  private showOtpSettingModal = false;

  private get otpSettingLabel() {
    return this.adminInfo.otp.used ? '재설정하기' : '설정하기';
  }

  private openOtpModal() {
    this.showOtpSettingModal = true;
  }

  private receiveMessage(e: MessageEvent) {
    if (e.data.otpSettingComplete) {
      this.adminInfo.otp.used = true;

      return;
    }
  }

  mounted() {
    window.addEventListener('message', this.receiveMessage);
  }

  beforeDestroy() {
    window.removeEventListener('message', this.receiveMessage);
  }


  private useExpire = 'false';
  private expireDate = addDay(new Date(), 30);
  private changeUseExpire() {
    if (!!this.adminInfo.expireDate) {
      this.expireDate = this.adminInfo.expireDate;
    }
    else {
      this.expireDate = addDay(new Date(), 30);
    }
  }

  private get isCommerceAccountMaster(): boolean {
    return this.adminInfo.commerceAccount && this.adminInfo.adminRole === 'MASTER';
  }

  get emailId(): string {
    return this.adminInfo.contact.email.split('@')[0];
  }
  set emailId(id: string) {
    this.adminInfo.contact.email = id + '@' + this.adminInfo.contact.email.split('@')[1];
    if (this.adminInfo.contact.email === '@') {
      this.adminInfo.contact.email = '';
    }
  }

  get emailDomain(): string {
    return this.adminInfo.contact.email.split('@')[1];
  }
  set emailDomain(domain: string) {
    this.adminInfo.contact.email = this.adminInfo.contact.email.split('@')[0] + '@' + domain;
    if (this.adminInfo.contact.email === '@') {
      this.adminInfo.contact.email = '';
    }
  }

  get mobileNo(): string {
    return this.adminInfo.contact.mobileNo;
  }
  set mobileNo(mobileNo: string) {
    this.adminInfo.contact.mobileNo = mobileNo;
    this.authSmsInfo.status = AUTH_BY_SMS.NONE;
  }

  private isMaster (): boolean {
    return this.adminInfo.adminRole === 'MASTER';
  }

  /**
   * vue init
   * - get data (부서 리스트, 직책 리스트, admin info, 권한 그룹 리스트)
   * - data init
   */
  public created(): void {
    Promise.all([this.getDepartments(), this.getJobDuties(), this.getAuthorityGroups(), this.getAdminsServiceByAdminNo()]).then((): void => {
      // select option init (department)
      for (let i = 0; i < this.departmentInfo.list.length; i++) {
        if (this.departmentInfo.list[i].departmentNo === this.adminInfo.department.no) {
          this.departmentInfo.select = i;
          break;
        }
      }

      // select option init (job duty)
      for (let i = 0; i < this.jobDutyInfo.list.length; i++) {
        if (this.jobDutyInfo.list[i].jobDutyNo === this.adminInfo.jobDuty.no) {
          this.jobDutyInfo.select = i;
          break;
        }
      }

      // select option init (auth group)
      for (let i = 0; i < this.authGroupInfo.list.length; i++) {
        if (this.authGroupInfo.list[i].no === this.adminInfo.authorityGroup.no) {
          this.authGroupInfo.select = i;
          break;
        }
      }
    });
  }

  /**
   * get departments list
   */
  private getDepartments(): Promise<void> {
    return this.$api
      .getDepartments()
      .then((response): void => {
        if (response && response.status === 200 && response.data) {
          this.departmentInfo.list = this.departmentInfo.list.concat(response.data);
        }
      })
      .catch((): void => {});
  }

  /**
   * get job duty list
   */
  private getJobDuties(): Promise<void> {
    return this.$api
      .getJobDuties()
      .then((response): void => {
        if (response && response.status === 200 && response.data) {
          this.jobDutyInfo.list = this.jobDutyInfo.list.concat(response.data);
        }
      })
      .catch((): void => {});
  }

  /**
   * get auth group (all)
   */
  private getAuthorityGroups(): Promise<void> {
    const request: GetAuthorityGroupsRequest = {
      params: {
        pageSize: 1000
      }
    };
    return this.$api
      .getAuthorityGroups(request)
      .then(response => {
        if (response && response.status === 200) {
          this.authGroupInfo.list = this.authGroupInfo.list.concat(response.data.contents);
        }
      })
      .catch();
  }

  /**
   * get admin info by admin no
   */
  private getAdminsServiceByAdminNo(): Promise<void> {
    const request: AdminsServiceByAdminNoRequest = {
      params: {
        adminNo: this.$route.params.adminNo
      }
    };

    return this.$api
      .getAdminsServiceByAdminNo(request)
      .then((response): void => {
        if (response && response.status === 200 && response.data) {
          if (!response.data.authorityGroup) {
            response.data.authorityGroup = this.adminInfo.authorityGroup;
          }
          if (!response.data.department) {
            response.data.department = this.adminInfo.department;
          }
          if (!response.data.jobDuty) {
            response.data.jobDuty = this.adminInfo.jobDuty;
          }
          if (!response.data.contact) {
            response.data.contact = this.adminInfo.contact;
          }

          response.data.jobPositionName = htmlRestore(response.data.jobPositionName);

          this.adminInfo = response.data;
					this.useIpAccessControl = response.data.permittedIpAddresses.length > 0;
					this.permittedIpAddress = response.data.permittedIpAddresses.join('\n');

          if (!!this.adminInfo.expireDate) {
            this.useExpire = 'true';
            this.expireDate = this.adminInfo.expireDate;
          } else {
            this.adminInfo.expireDate = '';
            this.useExpire = 'false';
          }
        }
      })
      .catch((): void => {});
  }

  /**
   * post auth sms (send sms)
   */
  private postAuthSms(): Promise<boolean> {
    const request: PostAuthSmsRequest = {
      data: {
        mobileNo: this.adminInfo.contact.mobileNo
      }
    };

    return this.$api
      .postAuthSms(request)
      .then((response): boolean => {
        if (response && response.status === 200) {
          return true;
        }
        return false;
      })
      .catch((): boolean => {
        return false;
      });
  }

  /**
   * get auth sms (check auth num)
   */
  private getAuthSms(): Promise<boolean> {
    const request: GetAuthSmsRequest = {
      params: {
        mobileNo: this.adminInfo.contact.mobileNo,
        key: this.authSmsInfo.certKey
      }
    };

    return this.$api
      .getAuthSms(request)
      .then((response: any): boolean => {
        if (response && response.status === 204) {
          return true;
        }
        return false;
      })
      .catch((): boolean => {
        return false;
      });
  }

  /**
   * put admin info by admin no
   */
  private putAdminsServiceByAdminNo(): Promise<boolean> {
    const request: PutAdminsServiceByAdminNoRequest = {
      params: {
        adminNo: this.$route.params.adminNo
      },
      data: {
        phone: this.adminInfo.contact.phoneNo,
        mobile: this.adminInfo.contact.mobileNo,
        jobPositionName: htmlEncode(this.adminInfo.jobPositionName),
        email: this.adminInfo.contact.email,
        externalAccessEnabled: this.adminInfo.externalAccessEnabled,
	      permittedIpAddresses: this.adminInfo.permittedIpAddresses,
        reasonDetail: this.reasonDetailModal.reasonDetail,
      }
    };

    if (this.authSmsInfo.status === AUTH_BY_SMS.COMPLETE && this.authSmsInfo.certKey.length > 0) {
      request.data.certKey = this.authSmsInfo.certKey;
    }

    if (this.adminInfo.authorityGroup.no > -1) {
      request.data.authorityGroupNo = this.adminInfo.authorityGroup.no;
    }

    if (this.adminInfo.department.no > -1) {
      request.data.departmentNo = this.adminInfo.department.no;
    }

    if (this.adminInfo.jobDuty.no > -1) {
      request.data.jobDutyNo = this.adminInfo.jobDuty.no;
    }

    if (this.useExpire === 'true' && !!this.expireDate) {
      request.data.expireDate = this.expireDate;
    }

    return this.$api
      .putAdminsServiceByAdminNo(request)
      .then((response: any): boolean => {
        if (response && response.status === 204) {
          return true;
        }
        return false;
      })
      .catch((error): boolean => {
        const isInvalidIP = error.data?.errors?.some(({ reason }) => reason.includes('Invalid IP'));
  
        if (isInvalidIP) {
          // 유효하지 않은 ip
          alert(this.$t('PARTNER_EDIT_PLZ_CHECK_PERMITTED_IP_ADDRESS'));
        }
        return false;
      });
  }

  /**
   * delete admin by admin no
   */
  private deleteAdminsServiceByAdminNo(): Promise<boolean> {
    const request: DeleteAdminsServiceByAdminNoRequest = {
      params: {
        adminNo: this.$route.params.adminNo,
        reasonDetail: this.reasonDetailModal.reasonDetail
      }
    };
    return this.$api
      .deleteAdminsServiceByAdminNo(request)
      .then((response: any): boolean => {
        if (response && response.status === 204) {
          return true;
        }
        return false;
      })
      .catch((): boolean => {
        return false;
      });
  }

  /**
   * select box handler (department, jobDuty)
   *
   * @param index - select index
   * @param name - department or jobDuty
   */
  private selectChanged(index: number, name: string): void {
    if (name === 'department') {
      this.departmentInfo.select = index;
      this.adminInfo.department.no = this.departmentInfo.list[index].departmentNo;
      this.adminInfo.department.name = this.departmentInfo.list[index].departmentName;
    } else if (name === 'jobDuty') {
      this.jobDutyInfo.select = index;
      this.adminInfo.jobDuty.no = this.jobDutyInfo.list[index].jobDutyNo;
      this.adminInfo.jobDuty.name = this.jobDutyInfo.list[index].jobDutyName;
    } else if (name === 'authorityGroup') {
      this.authGroupInfo.select = index;
      this.adminInfo.authorityGroup.no = this.authGroupInfo.list[index].no;
      this.adminInfo.authorityGroup.name = this.authGroupInfo.list[index].name;
    }
  }

  /**
   * send auth num to mobile
   */
  private sendAuthNumBySms(): void {
    // number 유효성 체크
    if (!isMobileNoValidated(this.adminInfo.contact.mobileNo)) {
      this.authSmsInfo.status = AUTH_BY_SMS.NONE;
      return;
    }

    this.postAuthSms().then((success: boolean): void => {
      if (success) {
        this.authSmsInfo.certKey = '';
        this.authSmsInfo.status = AUTH_BY_SMS.SENDING;
      }
    });
  }

  /**
   * check auth num
   */
  private checkAuthNum(): void {
    this.getAuthSms().then((success: boolean): void => {
      if (success) {
        this.authSmsInfo.status = AUTH_BY_SMS.COMPLETE;
      }
      else {
        this.authSmsInfo.status = AUTH_BY_SMS.ERROR;
        // alert(this.toI18n('COMMON_SERVER_ERROR', true));
      }
    });
  }

  /**
   * save admin info
   */
  private saveAdmin(): void {
    if (!this.isValidateForm()) {
      return;
    }

    const bConfirm = confirm(this.toI18n('COMMON_SAVE_CONFIRM', true));

    if (bConfirm) {
      this.putAdminsServiceByAdminNo().then((success: boolean) => {
        if (success) {
          alert(this.toI18n('COMMON_SAVE_SUCCESS', true));
          this.$router.back();
        }
      })
    }
  }

  /**
   * cancel page (history back)
   */
  private cancelPage(): void {
    const bConfirm = confirm(this.toI18n('CANCEL_MODIFY'));
    if (bConfirm) {
      this.$router.back();
    }
  }

  /**
   * delete admin
   */
  private deleteAdmin(): void {
    let bConfirm = false;
    const currentAdminNo = parseInt(this.$route.params.adminNo, 10);

    if (this.admin.no === currentAdminNo) {
      // bConfirm = confirm('이 계정은 현재 접속중인 운영자님의 계정입니다.\n삭제한 계정 정보는 복구되지 않으며 삭제 즉시 로그아웃 처리 됩니다.\n\n정말로 삭제하시겠습니까?');
      bConfirm = confirm(this.toI18n('CONFIRM_SELFMESSAGE'));
    } else {
      bConfirm = confirm(this.toI18n('CONFIRM_MESSAGE'));
    }

    if (bConfirm) {
      this.deleteAdminsServiceByAdminNo().then((success: boolean) => {
        if (success) {
          alert(this.toI18n('DELETE_COMPLETE'));
          this.$router.back();
        }
      });
    }
  }

  /**
   * show sms message
   */
  private isShowSmsMessage(messageId: string): boolean {
    switch (messageId) {
      case 'sms_certificated':
        return this.authSmsInfo.status === AUTH_BY_SMS.COMPLETE;
      case 'sms_cert_send':
        return this.authSmsInfo.status === AUTH_BY_SMS.SENDING;
      case 'mobileno_not_valid':
        return this.authSmsInfo.status === AUTH_BY_SMS.NONE;
      case 'sms_cert_success':
        return this.authSmsInfo.status === AUTH_BY_SMS.COMPLETE;
      case 'sms_auth_error':
        return this.authSmsInfo.status === AUTH_BY_SMS.ERROR;
    }

    return false;
  }

  /**
   * show sms auth num input
   */
  private isShowAuthInput(): boolean {
    return this.authSmsInfo.status === AUTH_BY_SMS.SENDING || this.authSmsInfo.status === AUTH_BY_SMS.ERROR;
  }

  /**
   * update external access enable changed
   */
  private externalAccessEnabledChanged(enabled: boolean) {
    this.adminInfo.externalAccessEnabled = enabled;
  }

  /**
   * check validate input before update admin info
   */
  private isValidateForm(): boolean {
    if (!this.isCommerceAccountMaster) {
      // 인증번호
      if (this.authSmsInfo.status !== AUTH_BY_SMS.COMPLETE) {
        alert(this.toI18n('RE_CHECK_SMS_AUTH'));
        return false;
      }

      // 이메일
      if (!this.adminInfo.contact.email || this.adminInfo.contact.email.length === 0) {
        alert(this.toI18n('INSERT_EMAIL'));
        return false;
      }

      if (!isEmailValidated(this.adminInfo.contact.email)) {
        alert(this.toI18n('RE_CHECK_FORMAT'));
        return false;
      }

      // 전화번호
      if (!this.adminInfo.contact.phoneNo || this.adminInfo.contact.phoneNo.length === 0) {
        alert(this.toI18n('INSERT_PHONE'));
        return false;
      }

      // 휴대폰 번호
      if (!this.adminInfo.contact.mobileNo || this.adminInfo.contact.mobileNo.length === 0) {
        alert(this.toI18n('INSERT_MOBILE'));
        return false;
      }
      if (!isMobileNoValidated(this.adminInfo.contact.mobileNo)) {
        alert(this.toI18n('RE_CHECK_MOBILE'));
        return false;
      }

      // 권한 그룹
      if (!this.isMaster() && this.adminInfo.authorityGroup.no < 0) {
        alert(this.toI18n('SELECT_AUTH_GROUP'));
        return false;
      }

    }

    // 직급
    // if (!this.adminInfo.jobPositionName || this.adminInfo.jobPositionName.length === 0) {
    //   alert(this.toI18n('INSERT_POSITION'));
    //   return false;
    // }

    // 운영자 접속가능 IP
		if (this.useIpAccessControl && !this.adminInfo.permittedIpAddresses?.length) {
			alert(this.toI18n('PLZ_IP_ADDRESS'));
			return false;
		}

    return true;
  }

  private toI18n(needToI18nStr: string, bCommon: boolean = false): string {
    return toI18n(this.$t((bCommon ? '' : 'ADMIN_EDIT_') + needToI18nStr));
  }
	
	// 운영자 IP 접속제한
	@Ref()
	private readonly ipAddressRef: HTMLTextAreaElement;
	
	private useIpAccessControl = false;
	private showIpAccessControlNotice = false;
	
	private permittedIpAddress = '';
	
	@Watch('useIpAccessControl')
	private resetPermittedIpAddresses() {
		if (this.useIpAccessControl) return;
		this.permittedIpAddress = '';
		this.adminInfo.permittedIpAddresses = [];
	}
	
	private handlePermittedIpAddressBlur() {
		this.adminInfo.permittedIpAddresses = this.permittedIpAddress.split('\n').map(v => v.trim()).filter(Boolean);
	}
}
